import { z } from "zod";

export enum TourType {
  ADD_ROTATION_BUTTON = "addRotationButton",
  HOMEPAGE_OVERVIEW = "homepageOverview",
  ROTA_FIRST_SHIFT = "rotaFirstShift",
  ROTA_ADD_TO_CALENDAR = "rotaAddToCalendar",
}

export const TourProgressSchema = z.object({
  addRotationButton: z.boolean(),
  homepageOverview: z.boolean(),
  rotaFirstShift: z.boolean(),
  rotaAddToCalendar: z.boolean(),
});

export type TourProgress = z.infer<typeof TourProgressSchema>;

export const defaultTourProgress: TourProgress = {
  addRotationButton: false,
  homepageOverview: false,
  rotaFirstShift: false,
  rotaAddToCalendar: false,
};